import { useIsStaff } from "./useIsStaff";
import { useIsPartner } from "./useIsPartner";

/**
 * A hook to determine if the user is a customer.
 *
 * @returns A boolean indicating whether the user is a customer.
 */
export const useIsCustomer = (): boolean => {
    const isStaff = useIsStaff();
    const isPartner = useIsPartner();

    return !isStaff && !isPartner;
};
